import { ADD_FIELD_FAIL, ADD_FIELD_REQUEST, ADD_FIELD_SUCCESS, DELETE_FIELD_FAIL, DELETE_FIELD_REQUEST, DELETE_FIELD_SUCCESS, GET_FIELD_FAIL, GET_FIELD_REQUEST, GET_FIELD_SUCCESS, UPDATE_FIELD_FAIL, UPDATE_FIELD_ORDER_FAIL, UPDATE_FIELD_ORDER_REQUEST, UPDATE_FIELD_ORDER_SUCCESS, UPDATE_FIELD_REQUEST, UPDATE_FIELD_SUCCESS, UPDATE_STATIC_FIELD_ORDER_FAIL, UPDATE_STATIC_FIELD_ORDER_REQUEST, UPDATE_STATIC_FIELD_ORDER_SUCCESS } from "../constant"

const initialState = {
  fieldData: []
}

const formBuilder = (state = initialState, action) => {
  switch (action.type) {

    //Get field 
    case GET_FIELD_REQUEST:
      return {
        ...state,
        fieldData: []
      }
    case GET_FIELD_SUCCESS:
      const tmpData = action.payload?.sort((a, b) => Number(a.su_order) - Number(b.su_order))
      return {
        ...state,
        fieldData: tmpData ?? []
      }
    case GET_FIELD_FAIL:
      return {
        ...state,
        fieldData: []
      }


    //Add field 
    case ADD_FIELD_REQUEST:
      return {
        ...state,
      }
    case ADD_FIELD_SUCCESS:
      const { id, data } = action.payload

      const field = {
        su_lead_gen_variable_id: id,
        su_survey_id: data.survey_id,
        su_label_and_options: JSON.stringify({ [data.language_code]: data.label }),
        su_name: data.name,
        su_options: JSON.stringify(data.options),
        su_order: data.order,
        su_form_variable_type: data.type,
        su_added_by: data.user
      }
      return {
        ...state,
        fieldData: [...state.fieldData, field]
      }
    case ADD_FIELD_FAIL:
      return {
        ...state,
      }

    //Update field 
    case UPDATE_FIELD_REQUEST:
      return {
        ...state,
      }
    case UPDATE_FIELD_SUCCESS:
      const tmpField = action.payload
      const tmpFieldData = state.fieldData?.map((field) => {
        let rawField = { ...field }
        if (Number(field.su_lead_gen_variable_id) === Number(tmpField.fieldId)) {
          rawField = {
            ...rawField,
            su_label_and_options: JSON.stringify({ [tmpField.language_code]: tmpField.label }),
            su_name: tmpField.name,
            su_options: JSON.stringify(tmpField.options)
          }
        }
        return rawField
      })
      return {
        ...state,
        fieldData: [...tmpFieldData]
      }
    case UPDATE_FIELD_FAIL:
      return {
        ...state,
      }

    //Update field 
    case DELETE_FIELD_REQUEST:
      return {
        ...state,
      }
    case DELETE_FIELD_SUCCESS:
      const deletedDield = action.payload
      const tmpDeletedFieldData = state.fieldData?.filter((field) => {
        return Number(field.su_lead_gen_variable_id) !== Number(deletedDield)
      })
      return {
        ...state,
        fieldData: [...tmpDeletedFieldData]
      }
    case DELETE_FIELD_FAIL:
      return {
        ...state,
      }


    //Change field order 
    case UPDATE_FIELD_ORDER_REQUEST:
      return {
        ...state,
      }
    case UPDATE_FIELD_ORDER_SUCCESS:
      const order = action.payload
      const preOrderedData = state.fieldData?.map((field) => {
        return { ...field, su_order: order[field.su_lead_gen_variable_id] }
      })
      const orderedData = preOrderedData?.sort((a, b) => Number(a.su_order) - Number(b.su_order))
      return {
        ...state,
        fieldData: orderedData
      }
    case UPDATE_FIELD_ORDER_FAIL:
      return {
        ...state,
      }

    //Update static field
    case UPDATE_STATIC_FIELD_ORDER_REQUEST:
      return {
        ...state,
      }
    case UPDATE_STATIC_FIELD_ORDER_SUCCESS:
      const updatedFieldData = action.payload
      const updatedData = state.fieldData?.map((field) => {
        let tmpField = { ...field }
        if (tmpField.su_name === updatedFieldData.name) {
          return {
            ...tmpField,
            su_label_and_options: JSON.stringify({ [updatedFieldData.language_code]: updatedFieldData.label }),
            su_options: JSON.stringify(updatedFieldData.options),
          }
        }
        return tmpField
      })
      return {
        ...state,
        fieldData: [...updatedData]
      }
    case UPDATE_STATIC_FIELD_ORDER_FAIL:
      return {
        ...state,
      }


    //Default
    default:
      return state;
  }
}

export { formBuilder }